// module
import React from 'react';
import { Link } from 'react-router-dom';

// my components
import DownloadLinks from '../components/DownloadLinks';
import OptionTable from '../components/OptionTable';
import CommandBox from '../components/CommandBox';
import ShowImg from '../components/ShowImg';

// img
import singleDownloadImg from '../img/download_img.png';
import figureImgS5 from '../img/Figure_S5.png';

function Gaap08(){
    window.scrollTo(0,0);
    return(
        <div className="content">
            <h2 className="content_title">Genome annotation</h2>
            <h2 className="content_title2">Structural annotation</h2>
            <h2 className="contnet_description">(4) Evidence-based consensus gene prediction</h2>
            <div className="content_text">
                When various gene prediction methods and tools are 
                used to derive gene structure from a genome, it is 
                essential to combine these results and obtain the single 
                consensus gene structure. GAAP employs EVM, which is widely 
                used. EVM combines various gene evidences, such as gene 
                predictions and protein/transcript alignments, into weighted 
                consensus gene structures.
            </div>
            <div className="content_command_title">EVM</div><br/>
            <li className="content_description">Download</li>
            <div className="content_download_box">
                <div className="content_download_img">
                    <img src={singleDownloadImg} alt="error"/>
                </div>
                <div className="content_download_links">
                    <br/><br/>
                    <DownloadLinks link="https://evidencemodeler.github.io" /><br/>
                </div>
            </div><br/>
            <li className="content_description">Weights File</li>
            <div className="content_text">
                EVM allows the user to weight each evidence using 
                a weights file. The weights file consists of three 
                columns: evidence class, type, and weight. The evidence 
                class can be one of the following: ABINITIO_PREDICTION, 
                PROTEIN, or TRANSCRIPT.
            </div>
            <CommandBox lines={[
                {data: `ABINITIO_PREDICTION augustus 1`},
                {data: `ABINITIO_PREDICTION maker 1`},
                {data: `PROTEIN genewise_protein_alignments 5`},
                {data: `TRANSCRIPT PASA_transcript_assemblies 10`},
            ]}
            /><br/>
            <div className="content_text">
                The process of running EVM consists of four phases: 
                partitioning, execution, combining, and conversion.
            </div>
            <li className="content_description">Partitioning Command</li>
            <div className="content_text">
                The input file is partitioned into smaller units, 
                depending on factors such as memory capacity.
            </div>
            <CommandBox lines={[
                {data: `EvmUtils/partition_EVM_inputs.pl --genome genome.fasta`},
                {data: `--gene_predictions gene_predictions.gff3`},
                {data: `--protein_alignments protein_alignment.gff3`},
                {data: `--transcript_alignments transcript_alignment.gff3 `},
                {data: `--segmentSize 100000 --overlapSize 10000 --partition_listing partitions_list.out`},
            ]}
            /><br/>
            <li className="content_description">Options for partitioning</li>
            <OptionTable
                data={[
                    {   option:'--genome',
                        desc:`specify the assembled genome file`},
                    {   option:'--gene_predictions',
                        desc:`specify the predicted gene structure file`},
                    {   option:'--protein_alignments',
                        desc:`specify the protein file`},
                    {   option:'--transcript_alignments',
                        desc:`specify the transcript file`},
                    {   option:'--partition_listing',
                        desc:`specify the output file(summary of the partitions)`},
                ]}
            /><br />
            <li className="content_description">Execution Command</li>
            <div className="content_text">
                The command list is generated first to enable executing 
                EVM commands in parallel, in a grid computing environment, 
                to improve performance.
            </div>
            <CommandBox lines={[
                {data: `EvmUtils/write_EVM_commands.pl --genome genome.fasta`},
                {data: `--weights weights.file --gene_predictions gene_predictions.gff3`},
                {data: `--protein_alignments protein_alignment.gff3`},
                {data: `--transcript_alignments transcript_alignment.gff3`},
                {data: `--output_file_name evm.out --partitions partitions_list.out > commands.list`},
                {data :`\n`},
                {data: `EvmUtils/execute_EVM_commands.pl commands.list`},
            ]}
            /><br/>
            <li className="content_description">Options for execution</li>
            <OptionTable
                data={[
                    {   option:'--weights',
                        desc:`specify the weights file`},
                    {   option:'--output_file_name',
                        desc:`specify the output file for EVM results`},
                    {   option:'--partitions',
                        desc:`specify the partition list file`},
                ]}
            /><br />
            <li className="content_description">Combining Command</li>
            <div className="content_text">
                The results for each small partitioned dataset, 
                obtained in the execution phase, are joined 
                into a single final result.
            </div>
            <CommandBox lines={[
                {data: `EvmUtils/recombine_EVM_partial_outputs.pl 
                        --partitions partitions_list.out --output_file_name evm.out`},
            ]}
            /><br/>
            <li className="content_description">Conversion Command</li>
            <div className="content_text">
                The final result file from the combining 
                phase is converted into a standard gff3 format.
            </div>
            <CommandBox lines={[
                {data: `EvmUtils/convert_EVM_outputs_to_GFF3.pl 
                --partitions partitions_list.out --output evm.out 
                --genome genome.fasta`},
            ]}
            /><br/>
            <li className="content_description">Output of EVM</li>
            <div className="content_text">
                evm.out.gff3: store the consensus gene structures&nbsp;
                <ShowImg name="(Supplementary Figure S5)"
                        src= {figureImgS5}
                />.
            </div><br/>
            <div className="content_buttons_div">
                <Link to="/Gaap07"><button className="content_button">Pre&ensp;</button></Link>
                <Link to="/Gaap09"><button className="content_button">Next</button></Link>
            </div>
        </div>
    );
}

export default Gaap08;